/**
 * Whether an instance is a customer's *validated* system.
 *
 * There is no field for this. x5-admin has never had one, so the only marker is
 * a suffix on `displayName`, written by hand and spelled at least five ways
 * across the live rows:
 *
 *   Abiomed Danvers VALIDATION INSTANCE
 *   Arcellx Maryland [VALIDATED]
 *   Arcellx Redwood City VALIDATED
 *   Genetika+ Neurokaire [Validated]
 *   egenesis-cambridge [VALIDATION INSTANCE 04202026]
 *
 * Matching the two words on a boundary covers all of them and leaves the
 * bracket, case and trailing-date variations alone. This is a presentation hint
 * only — it gates a confirmation step, never access — so a name that fooled it
 * either way would cost a prompt, not a tenancy check.
 *
 * If x5-admin ever grows a real flag, this is the one place that has to change.
 */
const VALIDATED = /\b(validated|validation)\b/i;

export function isValidatedInstance(displayName: string): boolean {
  return VALIDATED.test(displayName);
}
